import { useMediaQuery } from "@mantine/hooks";
import { useWeatherContext } from "../../_client/context";
import { ChartMonthLabels } from "./ChartMonthLabels";
import {
    CHART_DESKTOP_MARGIN,
    CHART_DESKTOP_SPACING,
    CHART_MOBILE_MARGIN,
    CHART_MOBILE_SPACING,
} from "./constants";
import { TemperatureButtons } from "./TemperatureButtons";
import { TemperatureGraph } from "./TemperatureGraph";
import { useTemperatureData } from "./useTemperatureData";
import { MonthlyWeather } from "./types";

type TemperatureChartProps = {
    monthlyWeather: MonthlyWeather;
};

export const TemperatureChart: React.FC<TemperatureChartProps> = ({
    monthlyWeather,
}) => {
    const { isCustomary } = useWeatherContext();

    const { avgMaxTempsC, avgMaxTempsF, avgMinTempsC, avgMinTempsF } =
        monthlyWeather;

    const minTemps = isCustomary ? avgMinTempsF : avgMinTempsC;
    const maxTemps = isCustomary ? avgMaxTempsF : avgMaxTempsC;

    const breakpointDesktop = "(min-width: 768px)";
    const isDesktop = useMediaQuery(breakpointDesktop, true);

    const spacing = isDesktop ? CHART_DESKTOP_SPACING : CHART_MOBILE_SPACING;
    const margin = isDesktop ? CHART_DESKTOP_MARGIN : CHART_MOBILE_MARGIN;

    const { minTempPoints, maxTempPoints, minTempsCurve, maxTempsCurve } =
        useTemperatureData(minTemps, maxTemps, spacing, margin);

    return (
        <>
            <TemperatureButtons />
            <TemperatureGraph
                minTemps={minTemps}
                maxTemps={maxTemps}
                minTempPoints={minTempPoints}
                maxTempPoints={maxTempPoints}
                minTempsCurve={minTempsCurve}
                maxTempsCurve={maxTempsCurve}
            />
            <ChartMonthLabels />
        </>
    );
};
